import { authCoreClient, authSciScoreClient } from './base';

export const Submissions = {
  all: (token, config) =>
    authSciScoreClient(token).get('/submission/list', config),
  get: (token, submissionId, config) =>
    authSciScoreClient(token).get(`/submission/get/${submissionId}`, config),
  list: (token, data, config) =>
    authSciScoreClient(token).post('/submission/list', data, config),
  add: (token, data) => authSciScoreClient(token).post('/submission/add', data),
};

export const User = {
  get: (token, config) => authSciScoreClient(token).get('/user/get', config),
  check: (token, config) =>
    authSciScoreClient(token).get('/user/check', config),
  create: (token, data) => authSciScoreClient(token).post('/user/create', data),
  update: (token, data) => authSciScoreClient(token).post('/user/update', data),
};

export const Orders = {
  all: (token, config) => authSciScoreClient(token).get('/order/list', config),
  get: (token, orderId, config) =>
    authSciScoreClient(token).get(`/order/get/${orderId}`, config),
  list: (token, config) => authSciScoreClient(token).get('/order/list', config),
  credits: (token) => authSciScoreClient(token).get('/order/credits'),
};

export const Products = {
  all: (token, config) =>
    authSciScoreClient(token).get('/product/list', config),
};

export const Payments = {
  createCheckOut: (token, data) =>
    authSciScoreClient(token).post('/payment/createcheckout', data),
};

// AsedaSciences Core Services
export const ApiCoreInfo = {
  get: (token) => authCoreClient(token).get('/info/'),
};

// AsedaSciences Core Services
export const UserRegistration = {
  get: (token, config) => authCoreClient(token).get('/user/', config),
  create: (token, data) => authCoreClient(token).post('/user/create', data),
  update: (token, data) => authCoreClient(token).post('/user/update', data),
  delete: (token, data) => authCoreClient(token).post('/user/delete', data),
};

// AsedaSciences Core Services
export const BugReports = {
  get: (token, config) => authCoreClient(token).get('/bugs/', config),
  submit: (token, data) => authCoreClient(token).post('/bugs/submit', data),
  update: (token, data) => authCoreClient(token).put('/bugs/update', data),
  delete: (token, id) => authCoreClient(token).post('/bugs/delete', id),
};
